/* Vendored shadcn/ui. Height bound to --control-h (110 §4). */
import { cn } from '@/lib/utils';

export function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      className={cn(
        'flex h-[var(--control-h)] w-full rounded-md border border-[var(--input)] bg-[var(--background)] px-[var(--pad-x)] py-[var(--pad-y)] text-[length:var(--ui-font)] text-[var(--foreground)] shadow-none transition-colors',
        'placeholder:text-[var(--muted-foreground)]',
        'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--ring)]',
        'aria-invalid:border-[var(--destructive)]',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
}
